// extracted by mini-css-extract-plugin
export default {"card":"styles__card--QiX47","agent-detail":"styles__agent-detail--1JzEp","detail-text":"styles__detail-text--NjTG4"};